import { Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="mt-32 border-t border-[color:var(--line-soft)] bg-[var(--bg-2)] no-print" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_whole-being-coach/artifacts/ozuwqyb6_IMG_1602.jpg"
              alt="YouFit by Sopfie Søndergaard"
              className="h-24 w-24 rounded-full object-cover ring-1 ring-[color:var(--line-soft)] shadow-sm"
            />
            <div className="flex items-baseline gap-1">
              <span className="font-serif text-3xl text-[color:var(--ink)] font-medium">Youfitbysopfie</span>
              <span className="font-serif text-base text-[color:var(--accent)] font-medium">.com</span>
            </div>
          </div>
          <p className="mt-3 text-[color:var(--ink-2)] text-sm leading-relaxed max-w-xs">
            {t("footer.tagline")}
          </p>
        </div>
        <div>
          <p className="overline mb-4">{t("footer.reach_out")}</p>
          <a href="mailto:Sopfie_soendergaard@hotmail.com" className="flex items-center gap-2 text-[color:var(--ink)] hover:text-[color:var(--accent)] transition-colors mb-2" data-testid="footer-email">
            <Mail size={16} strokeWidth={1.4} /> Sopfie_soendergaard@hotmail.com
          </a>
          <a href="tel:+4551490771" className="flex items-center gap-2 text-[color:var(--ink)] hover:text-[color:var(--accent)] transition-colors" data-testid="footer-phone">
            <Phone size={16} strokeWidth={1.4} /> 51 49 07 71
          </a>
        </div>
        <div>
          <p className="overline mb-4">{t("footer.book_session")}</p>
          <a href="https://youfit.planway.com/" target="_blank" rel="noreferrer" className="block text-[color:var(--ink)] hover:text-[color:var(--accent)] transition-colors mb-2" data-testid="footer-book-pt">
            → {t("footer.pt")}
          </a>
          <a href="https://youfit.planway.com/" target="_blank" rel="noreferrer" className="block text-[color:var(--ink)] hover:text-[color:var(--accent)] transition-colors" data-testid="footer-book-bt">
            → {t("footer.bt")}
          </a>
        </div>
      </div>
      <div className="border-t border-[color:var(--line-soft)] py-6 px-6 text-xs text-[color:var(--ink-3)] flex flex-wrap justify-between gap-2">
        <span>© {new Date().getFullYear()} Youfitbysopfie.com · {t("footer.made_with_care")}</span>
        <Link to="/studio-login" className="hover:text-[color:var(--accent)] transition-colors" data-testid="footer-studio-login">
          {t("footer.studio")}
        </Link>
      </div>
    </footer>
  );
}
